/**
 * Combine static (AST) and live-probe results into the binary verdict shown
 * in the row. Live trumps static when conclusive; otherwise we fall back
 * to the code analysis. `t` is the i18n function passed in so this module
 * stays free of React.
 */
export function combineResults({ staticResult, live, t }) {
    if (live.verdict === "open") {
        return {
            passed: false,
            detail:
                t("appPreview.detailLiveOpen", { status: live.status }) ||
                `Anyone can call this — live test returned ${live.status}`,
        };
    }
    if (live.verdict === "blocked") {
        const wrapped = live.warnings?.includes("wrappedStatus");
        return {
            passed: true,
            warning: wrapped,
            detail: wrapped
                ? t("appPreview.detailLiveBlockedWrapped", {
                      status: live.status,
                  }) ||
                  `Returned HTTP ${live.status} with a 4xx body — clients reading HTTP status treat this as success`
                : t("appPreview.detailLiveBlocked", { status: live.status }) ||
                  `Live test blocked (HTTP ${live.status})`,
        };
    }
    if (staticResult.passed) {
        return {
            passed: true,
            detail:
                t("appPreview.detailStaticEnforced") ||
                "Auth guard found in code",
        };
    }
    if (staticResult.reason === "referencedNotEnforced") {
        return {
            passed: false,
            detail:
                t("appPreview.detailReferencedOnly") ||
                "Auth signal referenced but not enforced",
        };
    }
    return {
        passed: false,
        detail: t("appPreview.detailNoGuard") || "No auth check found in code",
    };
}
